import { i18n } from "../../../language";
import store from "../../../store/";

let isDarkMode = () => store.state.user.darkMode;

function subFormatter(value) {
    let items = value
        .map((x) => {
            /* x.marker + x.seriesName + ":" + (Math.round(x.value))*/

            return (
                x.marker +
                i18n.t("message.calendarPassedTime", {
                    hour: Math.floor(x.value),
                    min: Math.round((x.value * 60) % 60),
                    name: x.seriesName,
                })
            );
        })
        .join("<br>");

    return value[0].name + "<br>" + items;
}

export default (data, series) => {
    series = series.map((x) => {
        x.name =
            x.name == "Online"
                ? i18n.t("message.online")
                : x.name == "Away"
                ? i18n.t("message.away")
                : x.name == "Busy"
                ? i18n.t("message.busy")
                : x.name == "Offline"
                ? i18n.t("message.offline")
                : x.name === "Disconnected"
                ? i18n.t("message.disconnected")
                : "";
        return x;
    });
    return {
        tooltip: {
            trigger: "axis",
            formatter: subFormatter,
        },
        legend: {
            data: [
                i18n.t("message.online"),
                i18n.t("message.away"),
                i18n.t("message.busy"),
                i18n.t("message.offline"),
                i18n.t("message.disconnected"),
            ],
            textStyle: {
                color: isDarkMode() ? "white" : "black",
            },
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
        },
        yAxis: {
            type: "value",
            scale: true,
            minInterval: 0.1,
            splitNumber: 24,
            color: isDarkMode() ? "white" : "black",
            axisLabel: {
                show: true,
                color: isDarkMode() ? "white" : "black",
            },
        },
        xAxis: {
            type: "category",
            data,
            lineStyle: {
                width: 1,
            },
            axisLabel: {
                show: true,
                color: isDarkMode() ? "white" : "black",
            },
        },
        series: series.map(({ name, data, color }) => ({
            name,
            type: "bar",
            stack: "stack",
            label: {
                formatter: (a, b) => {
                    let value = a.data;
                    let name = a.seriesName;
                    value = parseFloat(value);
                    if (value < 1) {
                        value = Math.round(value * 60);
                        // return `${value} dk boyunca ${name}`
                        if (value === 0) return "";
                        return i18n.t("message.calendarPassedTimeMin", {
                            value,
                            name,
                        });
                    } else {
                        const hour = Math.floor(value);
                        let min = value - hour;
                        min = Math.round(min * 60);
                        if (min >= 1) {
                            //return `${hour} saat ${min} dk boyunca ${name}`
                            return i18n.t("message.calendarPassedTime", {
                                hour,
                                min,
                                name,
                            });
                        } else {
                            // return `${hour} saat  boyunca ${name}`
                            return i18n.t("message.calendarPassedTimeHour", {
                                hour,
                                name,
                            });
                        }
                    }
                },
            },
            data,
            barWidth: 20,
            itemStyle: {
                color,
            },
        })),
    };
};
